var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#CBCBCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8031 11.6666C24.3394 11.6652 23.8801 11.7558 23.4518 11.9334C23.0235 12.1109 22.6347 12.3718 22.3081 12.7008L12.6289 22.3791C12.5048 22.5035 12.4231 22.6639 12.3956 22.8375L11.6764 27.3691C11.6557 27.4992 11.666 27.6322 11.7067 27.7575C11.7473 27.8827 11.817 27.9965 11.9101 28.0896C12.0032 28.1827 12.117 28.2524 12.2423 28.2931C12.3675 28.3337 12.5006 28.344 12.6306 28.3233L17.1664 27.6041C17.34 27.5766 17.5004 27.495 17.6247 27.3708L27.2989 17.6916C27.7925 17.1977 28.1284 16.5684 28.2643 15.8835C28.4001 15.1986 28.3298 14.4887 28.0622 13.8438C27.7946 13.1988 27.3417 12.6477 26.7608 12.2602C26.1799 11.8726 25.4972 11.6661 24.7989 11.6666H24.8031ZM16.6331 26L13.4997 26.5L13.9997 23.3691L20.9914 16.3766L23.6264 19.0116L16.6331 26ZM26.1206 16.5133L24.8039 17.8333L22.1664 15.1958L23.4839 13.8791C23.8388 13.5404 24.3104 13.3514 24.801 13.3514C25.2915 13.3514 25.7632 13.5404 26.1181 13.8791C26.2912 14.052 26.4285 14.2574 26.5221 14.4833C26.6158 14.7093 26.664 14.9516 26.664 15.1962C26.664 15.4409 26.6158 15.6831 26.5221 15.9091C26.4285 16.1351 26.2912 16.3404 26.1181 16.5133H26.1206Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilFileIcon);
export default __webpack_public_path__ + "static/media/pencilFileIcon.51b4fc30ca7498036eb2c2549fde2d7c.svg";
export { ForwardRef as ReactComponent };